import { PropsWithChildren } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { ProLightGripLines } from '@nexelem/icons/ProLightGripLines';
import { IconButton } from '@nexelem/components';

type DndSortableQueueGroupProps = {
  id: number;
};

/**
 * Should be very simple, because of DND performance
 */
export const DndSortableQueueGroup = ({ id, children }: PropsWithChildren<DndSortableQueueGroupProps>) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      className="flex items-center border-t border-t-border-container px-4 py-1 has-[.hidden-group]:bg-surface-container"
      ref={setNodeRef}
      style={style}
    >
      <IconButton className="touch-none" Icon={ProLightGripLines} size="small" {...attributes} {...listeners} />
      {children}
    </div>
  );
};
